'use strict';

var React = require('react');
var date = require('../../../helpers/date.js');

const useReactCalendar = ({ isUTC, month, onChange, onMonthChange, value, max, min, }) => {
    const fromReactCalendarDate = React.useCallback((date$1) => (isUTC ? date.toUTC(date$1) : date$1), [isUTC]);
    const toReactCalendarDate = React.useCallback((date$1) => (isUTC ? date.fromUTC(date$1) : date$1), [isUTC]);
    return {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        activeStartDate: React.useMemo(() => toReactCalendarDate(date.startOfMonth(month, { isUTC })), [month, toReactCalendarDate]),
        onActiveStartDateChange: React.useCallback(({ activeStartDate }) => onMonthChange(fromReactCalendarDate(activeStartDate)), [fromReactCalendarDate, onMonthChange]),
        value: React.useMemo(() => (value ? toReactCalendarDate(value) : null), [toReactCalendarDate, value]),
        onChange: React.useCallback((nextValue) => {
            onChange(nextValue ? fromReactCalendarDate(nextValue) : null);
        }, [onChange, fromReactCalendarDate]),
        maxDate: max && toReactCalendarDate(max),
        minDate: min && toReactCalendarDate(min),
    };
};

exports.useReactCalendar = useReactCalendar;
//# sourceMappingURL=useReactCalendar.js.map
